<template>
  <ion-app>
    <div class="ion-page">
      <ion-header>
        <ion-toolbar :style="toolbarStyle" mode="ios">
          <ion-title>{{ pageTitle }}</ion-title>
        </ion-toolbar>

        <ion-toolbar v-if="orderCode === ''" :style="searchToolbarStyle" class="search-toolbar">
          <ion-searchbar mode="ios" placeholder="Cari menu favorit..." :value="productName"
            @input="handleSearchInput" @ionClear="clearSearch"
            :style="searchbarStyle"
            class="custom-searchbar"></ion-searchbar>
        </ion-toolbar>
      </ion-header>

      <ion-content :fullscreen="true" class="main-content">
        <div class="container" v-if="orderCode === ''">
          <ion-col size="12" size-md="10" offset-md="1" size-lg="8" offset-lg="2">

            <outletSkeleton v-show="!show" />
            <outletHome v-show="show" v-if="orderCode === ''" :outlets="outlets" />

            <div class="status-stack" v-if="orderCode === ''">
              <transition-group name="fade-down">
                <div v-if="currentInvoice && this.timeLeft > 0" class="modern-status-card payment" key="payment">
                  <div class="status-info">
                    <small>Menunggu Pembayaran</small>
                    <h4>{{ currentInvoice }}</h4>
                    <p>Batas waktu: <strong>{{ formattedTime }}</strong></p>
                  </div>
                  <button class="action-link" @click="goToPayment()">Bayar Sekarang →</button>
                </div>

                <div v-if="hasActiveOrder == '1' && paymentSuccess" class="modern-status-card active" key="active">
                  <div class="status-info">
                    <small>Pesanan Aktif</small>
                    <h4>Pesanan sedang diproses</h4>
                  </div>
                  <button class="action-link" @click="goToOrder()">Cek Status</button>
                </div>
              </transition-group>
            </div>

            <!-- top pick component (system recommendations) -->
            <topPIckItem
              v-if="orderCode === '' && !productName"
              v-show="show"
              title="Top Picks"
              icon="🔥"
              :items="topPickItems"
              @add-product="handleAddProduct"
              :isInCart="isInCart"
            />
            <topPickSkeleton v-if="orderCode === '' && topPicksLoading && !productName" />

            <!-- user-defined product tag groups (resolved from catalog) -->
            <template v-if="show && orderCode === '' && !productName">
              <topPIckItem
                v-for="tag in productTagGroups"
                :key="`tag-${tag.tag_id}`"
                :title="tag.name"
                icon="🏷️"
                :items="tag.products"
                @add-product="handleAddProduct"
                :isInCart="isInCart"
              />
            </template>
            <topPickSkeleton v-if="orderCode === '' && productTagsLoading && !productTagGroups.length && !productName" />

            <skeleton v-if="!show" />

            <div class="menu-section" v-if="!(productName && filteredCategories.length === 0)">
              <outletCategory ref="categoryRef" v-if="orderCode === ''" @get-items="getItems"
                @details-product="detailsProduct" :categories="filteredCategories" :productFormLocalStorage="product"
                :show="show" :linkMenus="linkMenus" @open-link-menu="onOpenLinkMenu" />
            </div>

            <div class="no-search-results" v-if="productName && filteredCategories.length === 0 && show && orderCode === ''">
              <ion-icon :icon="searchOutline" class="no-results-icon"></ion-icon>
              <h3>Menu tidak ditemukan</h3>
              <p>Coba gunakan kata kunci pencarian lain</p>
            </div>
          </ion-col>

          <footer class="modern-footer" v-if="orderCode === ''">
            <p>Powered by <span>UNIQ</span></p>
          </footer>
        </div>

        <transition name="pop">
          <div class="fab-cart-container" v-if="qty() > 0 && !order && orderCode === ''">
            <button class="fab-cart" @click="orderList">
              <div class="icon-badge-wrapper">
                <ion-icon size="large" :icon="bagHandleOutline"></ion-icon>
                <span class="cart-badge">{{ qty() }}</span>
              </div>
              <span class="cart-text">Lihat Keranjang</span>
            </button>
          </div>
        </transition>

        <outletCheckOrder @orderData="OrderData" @changeListOrder="changeListOrder" :orderList="product"
          :editID="editID" :order="order" />
        <paymentOptionDialog @orderData="OrderData" :resetOrderList="resetOrderList" />
        <productDetails :productDetails="productDetails" :checkProductAlready="checkProductAlready()"
          @generate-url="generateUrl" @add-product-from-details="addProductFromDetails" />
        <linkMenuDialog :isOpen="showLinkMenuDialog" :parentProduct="parentProductForLinkMenu"
          :linkMenus="linkMenus" :categories="categories" :topPickItems="topPickItems"
          @close="closeLinkMenuDialog" @confirm="confirmLinkMenuSelection" />

        <div v-if="orderCode !== ''" class="order-result-view">
          <outletOrder :orderCode="[orderCode, qrCode, hours, minutes]" />
        </div>

        <!-- input url -->
        <inputUrlCopy v-show="showLinkInput" v-bind:url="url" v-bind:showLinkInput="showLinkInput"></inputUrlCopy>
      </ion-content>
    </div>
  </ion-app>
</template>

<script>
// @ is an alias to /src
import outletCheckOrder from "@/components/outletCheckOrder";
import paymentOptionDialog from "@/components/paymentOptionDialog";
import outletHome from "@/components/outletHome";
import outletCategory from "@/components/outletCategory";
import outletOrder from "@/components/outletOrder";
import productDetails from "@/components/productDetails";
import linkMenuDialog from "@/components/linkMenuDialog";
import inputUrlCopy from "@/components/inputUrlCopy";
import skeleton from "@/components/skeleton/skeleton";
import { useOutletStore } from "@/stores/outlet"
import topPIckItem from "../components/topPIckItem.vue";
import { IonIcon, IonHeader, IonToolbar, IonTitle, IonSearchbar, IonContent, IonCol, IonApp, alertController, loadingController } from "@ionic/vue";
import { getCurrentInvoice, storage, STORAGE_KEYS } from "@/utils/storage";
import { bagHandleOutline, searchOutline } from "ionicons/icons"
import topPickSkeleton from "../components/skeleton/topPickSkeleton.vue"
import outletSkeleton from "../components/skeleton/outletSkeleton.vue";

export default {
  name: "home",
  components: {
    outletHome,
    outletCategory,
    outletCheckOrder,
    paymentOptionDialog,
    outletOrder,
    productDetails,
    linkMenuDialog,
    inputUrlCopy,
    skeleton,
    IonIcon,
    topPIckItem,
    // IonCard, // <-- HAPUS INI
    IonHeader,
    IonToolbar,
    // IonButtons,
    // IonBackButton,
    IonTitle,
    IonSearchbar,
    IonContent,
    topPickSkeleton,
    outletSkeleton,

    IonCol,
    IonApp
  },
  props: {
    timeout: { type: Number, default: 5000 },
  },
  data() {
    return {
      bagHandleOutline,
      searchOutline,
      categories: [],
      filteredCategories: [],
      outlets: [],
      product: [],
      order: false,
      orderCode: "",
      qrCode: "",
      hours: "",
      minutes: "",
      wa: storage.getWaNumber() || "",
      productName: "",
      editID: "",
      disableSendWa: false,
      historyOrder: storage.getHistoryOrder() ?? [],
      showProductDetails: false,
      productDetails,
      url: "",
      showLinkInput: false,
      backdropOrder: false,
      show: false,
      showHistoryLastOrder: false,
      currentInvoice: getCurrentInvoice(),
      timeLeft: 0,
      timer: null,
      hasActiveOrder: null,
      topPickItems: [],
      topPicksLoading: true,
      /** Raw tags from API: [{ tag_id, name, product_ids }] */
      productTags: [],
      /** Resolved for UI: [{ tag_id, name, products }] */
      productTagGroups: [],
      productTagsLoading: true,
      paymentSuccess: false,
      checkTransaction: null,
      linkMenus: [],
      showLinkMenuDialog: false,
      parentProductForLinkMenu: null,
      searchDebounceTimer: null,
      appConfig: null,
    };
  },
  //* Fetch Api *//
  async created() {
    const deadline = storage.getOrderDeadline()
    if (deadline) {
      const now = Math.floor(Date.now() / 1000)
      const diff = parseInt(deadline, 10) - now;
      this.timeLeft = diff > 0 ? diff : 0;
    } else {
      const newDeadLine = Math.floor(Date.now() / 1000) + this.timeLeft;
      storage.setOrderDeadline(newDeadLine)
    }

    let id = this.$route.params.id;
    this.editID = this.$route.query.editID || this.$route.query.edit_id || this.$route.query['edit-id'] || "";
    await this.getAppConfig();
    await this.getOutlet(id);
    await this.getProductCategory(id);

    let myHeaders = new Headers();
    myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const getTopPickProduct = async () => {
      // Instant paint from cache (stale-while-revalidate)
      const cached = storage.getTopPicks(id);
      if (cached && Array.isArray(cached.data)) {
        this.topPickItems = cached.data;
        this.topPicksLoading = false;
      }

      try {
        const res = await fetch(
          `${process.env.VUE_APP_BASE_URL}v1/product/recommendation?outlet_id=${id}`,
          requestOptions
        );
        if (!res.ok) {
          throw new Error(`Top picks fetch failed: ${res.status}`);
        }
        const data = await res.json();
        const items = data.data ?? [];
        this.topPickItems = items;
        storage.setTopPicks(id, items);
      } catch (error) {
        console.error("Error fetching top picks:", error);
        // Keep cache if we already applied it; otherwise try expired as last resort
        if (!this.topPickItems.length) {
          const stale = storage.getTopPicks(id, { allowStale: true });
          this.topPickItems =
            stale && Array.isArray(stale.data) ? stale.data : [];
        }
      } finally {
        this.topPicksLoading = false;
      }
    }

    const getProductsInCard = async () => {
      if (!this.editID || this.editID === "0") {
        return;
      }

      const res = await fetch(
        `${process.env.VUE_APP_BASE_URL}v1/transaction/self_order/${id}/${this.editID}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == 200) {
        const products = [].concat(
          ...this.categories.map((item) => item.products)
        );
        this.product = data.data.order_list.map((item) => {
          const parentProduct = products.find((p) => p.product_detail_id == item.product_detail_id);
          const mappedItem = {
            note: item.note,
            price: item.price,
            product_detail_id: item.product_detail_id,
            product_name: parentProduct ? parentProduct.name : "",
            qty: item.qty,
            photo: parentProduct ? parentProduct.photo : "",
            tax: parentProduct && parentProduct.tax ? parentProduct.tax.filter(t => t.tax_status === "permanent") : [],
          };
          const extraSource = item.link_menu || item.extra;
          if (extraSource && Array.isArray(extraSource)) {
            const isGroupedFormat = extraSource.length > 0 && ('link_menu_detail' in extraSource[0] || 'linkmenu_id' in extraSource[0]);

            if (isGroupedFormat) {
              mappedItem.link_menu = extraSource.map((group) => {
                const mappedGroup = {
                  linkmenu_id: group.linkmenu_id,
                  product_fkid: group.product_fkid,
                  link_menu_detail: []
                };
                if (group.link_menu_detail && Array.isArray(group.link_menu_detail)) {
                  mappedGroup.link_menu_detail = group.link_menu_detail.map((detail) => {
                    const childProduct = products.find((p) => p.product_detail_id == detail.product_detail_fkid);
                    return {
                      linkmenu_detail_id: detail.linkmenu_detail_id,
                      product_detail_fkid: detail.product_detail_fkid,
                      price_add: detail.price_add,
                      product_name: childProduct ? childProduct.name : "",
                      photo: childProduct ? childProduct.photo : "",
                      tax: childProduct && childProduct.tax ? childProduct.tax.filter(t => t.tax_status === "permanent") : [],
                    };
                  });
                }
                return mappedGroup;
              });
            } else {
              // Convert flat list into the grouped structure for consistency
              mappedItem.link_menu = extraSource.map((child) => {
                const childProduct = products.find((p) => p.product_detail_id == child.product_detail_id);
                return {
                  linkmenu_id: 0,
                  product_fkid: 0,
                  link_menu_detail: [{
                    linkmenu_detail_id: 0,
                    product_detail_fkid: child.product_detail_id,
                    price_add: child.price,
                    product_name: childProduct ? childProduct.name : "",
                    photo: childProduct ? childProduct.photo : "",
                    tax: childProduct && childProduct.tax ? childProduct.tax.filter(t => t.tax_status === "permanent") : [],
                  }]
                };
              });
            }
          }
          return mappedItem;
        });
      }
    };
    const getProductLinkMenu = async () => {
      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);
      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      
      let allLinkMenus = [];
      let page = 1;
      const pageSize = 50;
      let hasMore = true;

      try {
        while (hasMore) {
          const res = await fetch(
            `${process.env.VUE_APP_BASE_URL}v1/product-link-menu?outlet_id=${id}&page=${page}&page_size=${pageSize}`,
            requestOptions
          );
          if (!res.ok) {
            throw new Error(`Failed to fetch link menus at page ${page}`);
          }
          const data = await res.json();
          const items = data.data ?? [];
          allLinkMenus.push(...items);

          if (items.length < pageSize) {
            hasMore = false;
          } else {
            page++;
          }
        }
        this.linkMenus = allLinkMenus;
      } catch (error) {
        console.error("Error fetching product link menus:", error);
      }
    };
    getTopPickProduct()
    this.getProductTags()
    getProductLinkMenu()
    getProductsInCard();
  },
  mounted() {
    if (this.timeLeft > 0) {
      this.startTimer();
    }
    this.paymentSuccess = storage.getPaymentSuccess() || false

    const paymentDeadline = storage.getPaymentOrderDeadline()
    if (paymentDeadline !== undefined) {
      const dateNow = Math.floor(Date.now() / 1000);
      if (dateNow >= paymentDeadline) {
        storage.removeMultiple([
          STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
          STORAGE_KEYS.HAS_ACTIVE_ORDER,
          STORAGE_KEYS.ACTIVE_ORDER,
          STORAGE_KEYS.LAST_ORDER_STATUS,
          STORAGE_KEYS.CURRENT_INVOICE
        ])
        this.hasActiveOrder = null
      }
    }
    this.lastOrderStatus = storage.getLastOrderStatus()
    if (this.lastOrderStatus === "taken") {
      storage.removeMultiple([
        STORAGE_KEYS.HAS_ACTIVE_ORDER,
        STORAGE_KEYS.LAST_PAYMENT,
        STORAGE_KEYS.LAST_ORDER_STATUS,
        STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
        STORAGE_KEYS.HAS_ACTIVE_ORDER,
        STORAGE_KEYS.ACTIVE_ORDER,
        STORAGE_KEYS.PAYMENT_SUCCESS,
        STORAGE_KEYS.CURRENT_INVOICE
      ])

      this.hasActiveOrder = null
    }
    this.syncActiveOrder()
    const invoice = getCurrentInvoice()
    if (invoice) {
      this.checkTransaction = setInterval(() => {
        this.checkCurrentTransaction()
      }, 5000);
    }
  },
  beforeMount() {
    if (
      storage.getLastOrder() != undefined
    ) {
      const outlet_id = this.$route.params.id;
      let lastOrders = storage.getLastOrder();
      if (lastOrders && lastOrders.outlet_id == outlet_id)
        this.product = lastOrders.products;
    }
    setTimeout(() => {
      this.show = true;
    }, 2000);

    //* show history last order
    let outlet_id = this.$route.params.id;
    if (
      this.historyOrder.items != undefined &&
      this.historyOrder.items.length > 0
    ) {
      if (this.historyOrder.outlet_id == outlet_id) {
        let expired = this.historyOrder.trans.expired;
        let d = new Date(expired);
        let now = new Date();

        if (now.getTime() >= d.getTime()) {
          storage.remove(STORAGE_KEYS.HISTORY_ORDER);
        } else {
          this.showHistoryLastOrder = true;
        }
      }
    }
  },
  computed: {
    invoiceId() {
      return this.$route.query['invoice-id']
    },
    outletStore() {
      return useOutletStore()
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
        .toString()
        .padStart(2, "0")
      const seconds = (this.timeLeft % 60).toString().padStart(2, "0")
      return `${minutes}:${seconds}`
    },
    pageTitle() {
      if (this.appConfig && this.appConfig.asset && this.appConfig.asset.app_name) {
        return `Self Order - ${this.appConfig.asset.app_name}`;
      }
      return "Self Order";
    },
    toolbarStyle() {
      if (this.appConfig && this.appConfig.asset && this.appConfig.asset.color && this.appConfig.asset.color.primary) {
        return {
          '--background': this.appConfig.asset.color.primary,
          '--color': '#ffffff'
        };
      }
      return {
        '--background': '#1a1a1a',
        '--color': '#ffffff'
      };
    },
    searchToolbarStyle() {
      if (this.appConfig && this.appConfig.asset && this.appConfig.asset.color && this.appConfig.asset.color.primary) {
        return {
          '--background': this.appConfig.asset.color.primary
        };
      }
      return {
        '--background': '#1a1a1a'
      };
    },
    searchbarStyle() {
      const primaryColor = (this.appConfig && this.appConfig.asset && this.appConfig.asset.color && this.appConfig.asset.color.primary) 
        ? this.appConfig.asset.color.primary 
        : '#1a1a1a';
      
      const isLight = this.isLightColor(primaryColor);
      
      if (isLight) {
        return {
          '--background': '#f1f5f9',
          '--color': '#1e293b',
          '--placeholder-color': '#64748b',
          '--icon-color': '#64748b',
          '--clear-button-color': '#64748b',
          '--border-radius': '12px',
          'border': '1px solid #cbd5e1'
        };
      } else {
        return {
          '--background': '#ffffff',
          '--color': '#1e293b',
          '--placeholder-color': '#64748b',
          '--icon-color': '#64748b',
          '--clear-button-color': '#64748b',
          '--border-radius': '12px',
          '--box-shadow': '0 2px 8px rgba(0, 0, 0, 0.08)'
        };
      }
    }
  },
  methods: {
    async checkCurrentTransaction() {
      const invoice = getCurrentInvoice()
      console.log({ invoice })
      if (invoice) {
        const url = `${process.env.VUE_APP_BASE_URL}v2/transaction/${invoice}`

        const myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
        };

        const res = await fetch(url, requestOptions)
        if (res.ok) {
          const data = await res.json()
          if (data.data.status === "reject" || data.data.status === "cancel") {
            storage.removeMultiple([
              STORAGE_KEYS.ORDER_DEADLINE,
              STORAGE_KEYS.LAST_PAYMENT,
              STORAGE_KEYS.CURRENT_INVOICE,
              STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
              STORAGE_KEYS.HAS_ACTIVE_ORDER,
              STORAGE_KEYS.ACTIVE_ORDER,
              STORAGE_KEYS.LAST_ORDER_STATUS,
              STORAGE_KEYS.ORDER_DEADLINE,
              STORAGE_KEYS.PAYMENT_DEADLINE,
            ])
            this.hasActiveOrder = null
            this.timeLeft = 0;
            this.currentInvoice = null
            clearInterval(this.checkTransaction)
          }
        }
      }
    },
    syncActiveOrder() {
      this.hasActiveOrder = storage.getHasActiveOrder()
    },
    // Use local cart state — do not depend on outletCategory ref
    // (that component unmounts when orderCode is set after place order).
    isInCart(detailId) {
      if (detailId == null || !Array.isArray(this.product)) return false;
      const item = this.product.find(
        (p) => p.product_detail_id == detailId
      );
      return item ? item.qty : 0;
    },
    handleAddProduct(product) {
      if (this.$refs.categoryRef) {
        this.$refs.categoryRef.addFromTopPick(product);
        return;
      }
      // Fallback if category list is not mounted
      this.product = [
        ...this.product,
        {
          product_name: product.name,
          note: "",
          price: product.price_sell,
          product_id: product.product_id,
          product_detail_id: product.product_detail_id,
          photo: product.photo,
          qty: 1,
          tax: product.tax,
        },
      ];
      const outlet_id = this.$route.params.id;
      storage.setLastOrder(
        JSON.stringify({ outlet_id, products: this.product })
      );
    },
    goToOrder() {
      const id = this.$route.params.id;
      const inv = getCurrentInvoice()
      this.$router.push(`/${id}/order/payment/qris/code?invoice-id=${inv}`)
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
          this.currentInvoice = undefined

          storage.removeMultiple([
            STORAGE_KEYS.HAS_ACTIVE_ORDER,
            STORAGE_KEYS.LAST_PAYMENT,
            STORAGE_KEYS.LAST_ORDER_STATUS,
            STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
            STORAGE_KEYS.ACTIVE_ORDER,
            STORAGE_KEYS.PAYMENT_SUCCESS,
            STORAGE_KEYS.CURRENT_INVOICE
          ])

          this.hasActiveOrder = null
          this.cancelOrder()
        }
      }, 1000)
    },
    async cancelOrder() {
      const invoice = this.outletStore.currentInvoice
      const url = `${process.env.VUE_APP_BASE_URL}v2/transaction/${invoice}/status`

      const myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);

      const body = new URLSearchParams({
        status: "cancel"
      })

      const requestOptions = {
        method: "PUT",
        body: body,
        headers: myHeaders,
      };

      const res = await fetch(url, requestOptions)

      if (res.ok) {
        const data = await res.json()
        console.log(data)
      }
      storage.removeMultiple([
        STORAGE_KEYS.ORDER_DEADLINE,
        STORAGE_KEYS.CURRENT_INVOICE
      ])
      const outletStore = useOutletStore();
      const outlet = outletStore.outlet;
      this.$router.push(`/${outlet.outlet_id}`)
    },
    goToPayment() {
      const id = this.$route.params.id;
      this.$router.push(`/${id}/order/payment/qris/waiting`)
    },
    resetOrderList() {
      this.product = [];
    },
    //* checkout history last order
    deals(historyOrder) {
      this.showHistoryLastOrder = false;
      this.orderCode = historyOrder.trans.order_code;
      this.qrCode = historyOrder.trans.qrcode;
      let expired = historyOrder.trans.expired;
      let date = new Date(expired);
      this.hours = date.getHours();
      this.minutes = date.getMinutes();

    },
    getPaymentExpired() {
      const orderDeadLine = storage.getOrderDeadline()

      let date = new Date(Number(orderDeadLine));
      let hours = date.getHours();
      let minute = date.getMinutes();

      return `${hours.toString()}:${minute.toString()}`;
    },
    expiredHistoryOrder(historyOrder) {
      if (historyOrder != "") {
        let expired = historyOrder.trans.expired;
        let date = new Date(expired);
        let hours = date.getHours();
        let minute = date.getMinutes();

        return `${hours.toString()}:${minute.toString()}`;
      }
    },
    changeListOrder(newOrder) {
      this.product = newOrder;
      const outlet_id = this.$route.params.id;
      storage.setLastOrder(JSON.stringify({ outlet_id, products: newOrder }))
      if (this.product.length == 0) {
        this.backdropOrder = !this.backdropOrder;
        this.order = false;
      }
    },
    prodNameInHisOrder() {
      if (this.historyOrder.items != undefined) {
        let prodName = this.historyOrder.items
          .map((item) => item.product_name)
          .toString()
          .slice(0, 35);
        return prodName + "...";
      }
    },
    //* Map raw API categories to UI shape
    mapCategories(rawList) {
      if (!Array.isArray(rawList)) return [];
      return rawList.map((item) => ({
        opened: false,
        has_order: false,
        ...item,
      }));
    },
    applyCategories(rawList) {
      this.categories = this.mapCategories(rawList);
      // Preserve active search filter if user typed while revalidating
      if (this.productName) {
        this.searchProducts();
      } else {
        this.filteredCategories = this.categories;
      }
      // Tag groups depend on the outlet product catalog
      this.resolveProductTags();
    },
    /**
     * Flatten catalog products and resolve tag product_ids into full product objects.
     * Only products present in the current outlet catalog are shown.
     */
    resolveProductTags() {
      if (!this.productTags.length || !this.categories.length) {
        this.productTagGroups = [];
        return;
      }

      const products = [].concat(
        ...this.categories.map((item) => item.products || [])
      );
      const byId = new Map();
      for (const p of products) {
        if (p == null || p.product_id == null) continue;
        const key = Number(p.product_id);
        if (!byId.has(key)) {
          byId.set(key, p);
        }
      }

      this.productTagGroups = this.productTags
        .map((tag) => ({
          tag_id: tag.tag_id,
          name: tag.name,
          products: (tag.product_ids || [])
            .map((pid) => byId.get(Number(pid)))
            .filter(Boolean),
        }))
        .filter((group) => group.products.length > 0);
    },
    /**
     * Fetch highlight tags (IDs only), then resolve against loaded catalog.
     * Tags can load from cache immediately; network revalidates.
     */
    async getProductTags() {
      const cached = storage.getProductTags();
      if (cached && Array.isArray(cached.data)) {
        this.productTags = cached.data;
        this.resolveProductTags();
        if (this.productTagGroups.length) {
          this.productTagsLoading = false;
        }
      }

      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      try {
        const res = await fetch(
          `${process.env.VUE_APP_BASE_URL}v1/product/tag`,
          requestOptions
        );
        if (!res.ok) {
          throw new Error(`Product tags fetch failed: ${res.status}`);
        }
        const data = await res.json();
        const tags = data.data ?? [];
        this.productTags = tags;
        storage.setProductTags(tags);
        this.resolveProductTags();
      } catch (error) {
        console.error("Error fetching product tags:", error);
        if (!this.productTags.length) {
          const stale = storage.getProductTags({ allowStale: true });
          if (stale && Array.isArray(stale.data)) {
            this.productTags = stale.data;
            this.resolveProductTags();
          }
        }
      } finally {
        this.productTagsLoading = false;
      }
    },
    //* Get product category by outlet id (cache + network revalidate)
    async getProductCategory(id) {
      // Instant paint from valid cache
      const cached = storage.getProductCategories(id);
      if (cached && Array.isArray(cached.data)) {
        this.applyCategories(cached.data);
      }

      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      try {
        const res = await fetch(
          `${process.env.VUE_APP_BASE_URL}v1/product/outlet/${id}/group/subcategory?include=tax`,
          requestOptions
        );
        if (!res.ok) {
          throw new Error(`Product category fetch failed: ${res.status}`);
        }
        const data = await res.json();
        const rawList = data["data"] ?? [];
        this.applyCategories(rawList);
        // Cache raw API payload (without UI flags) for next visit
        storage.setProductCategories(id, rawList);
      } catch (error) {
        console.error("Error fetching product categories:", error);
        // If we had nothing fresh, fall back to expired cache
        if (!this.categories.length) {
          const stale = storage.getProductCategories(id, { allowStale: true });
          if (stale && Array.isArray(stale.data)) {
            this.applyCategories(stale.data);
          }
        }
      }
    },
    //* Get outlet by id
    async getOutlet(id) {
      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      const res = await fetch(
        `${process.env.VUE_APP_BASE_URL}v1/outlet/detail/${id}`,
        requestOptions
      );
      let outletData = await res.json();
      this.outlets = outletData["data"];
    },
    async getAppConfig() {
      try {
        let myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);
        let requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };
        const res = await fetch(
          `${process.env.VUE_APP_BASE_URL}v1/app-config`,
          requestOptions
        );
        if (res.ok) {
          const configData = await res.json();
          if (configData && (configData.status === true || configData.message === "success")) {
            this.appConfig = configData.data || null;
            this.applyDynamicColors();
          }
        }
      } catch (err) {
        console.warn("Failed to fetch app-config:", err);
      }
    },
    applyDynamicColors() {
      if (!this.appConfig || !this.appConfig.asset || !this.appConfig.asset.color) return;
      const colors = this.appConfig.asset.color;
      const root = document.documentElement;
      if (colors.primary) {
        root.style.setProperty('--primary-color', colors.primary);
      }
      if (colors.primary_dark) {
        root.style.setProperty('--primary-dark-color', colors.primary_dark);
      }
      if (colors.accent) {
        root.style.setProperty('--accent-color', colors.accent);
      }
      if (colors.secondary) {
        root.style.setProperty('--secondary-color', colors.secondary);
      }
    },
    isLightColor(hex) {
      if (!hex || typeof hex !== 'string') return false;
      let c = hex.replace('#', '');
      if (c.length === 3) c = c.split('').map(x => x + x).join('');
      if (c.length !== 6) return false;
      const r = parseInt(c.substr(0, 2), 16);
      const g = parseInt(c.substr(2, 2), 16);
      const b = parseInt(c.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 185;
    },
    //* Get items from PandaCategory Component
    getItems(items) {
      this.product = items;
    },
    //* Sum Order
    qty() {
      if (this.product.length > 0) {
        let qty_sum = 0;

        this.product.forEach(function (obj) {
          qty_sum += obj["qty"];
        });
        return qty_sum;
      }
    },
    searchProducts() {
      if (this.productName) {
        const products = [].concat(
          ...this.categories.map((item) => item.products)
        );

        this.filteredCategories = products.filter((product) => {
          const name = product.name.toLowerCase();
          const description = product.description ?? "";
          if (
            name.includes(this.productName.toLowerCase()) ||
            description.toLowerCase().includes(this.productName.toLowerCase())
          ) {
            return product;
          }
          return;
        });
      } else {
        this.filteredCategories = this.categories;
      }
    },
    handleSearchInput(event) {
      const val = event ? (event.target ? event.target.value : '') : '';
      this.productName = val;

      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      if (!val || val.trim() === '') {
        // Instant search on clear/empty input
        this.searchProducts();
      } else {
        // Debounce typing by 300ms
        this.searchDebounceTimer = setTimeout(() => {
          this.searchProducts();
        }, 300);
      }
    },
    clearSearch() {
      this.productName = '';
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.searchProducts();
    },
    //* Check before order
    async orderList() {
      this.backdropOrder = !this.backdropOrder;
      // this.order = true;
      this.outletStore.setOrder(true)
      this.outletStore.setShowCartModal(true)
    },
    hiding(hiden) {
      this.order = hiden;
      this.outletStore.setOrder(false)
    },
    //* Order data
    OrderData(order_code, qrcode, hours, minutes) {
      this.orderCode = order_code;
      this.qrCode = qrcode;
      this.hours = hours;
      this.minutes = minutes;
    },
    //* Sending WhatsApp
    sendWa(e) {
      e.preventDefault();
      const isValidNumber = /(^\d{11}$)|(^\d{12}$)|(^\d{13}$)/.test(this.wa);

      if (!isValidNumber) {
        this.showAlert();
        this.wa = "";
      } else {
        this.presentLoading();
        this.sending();
        storage.setWaNumber(this.wa)
      }
    },
    //* Sending WhatsApp api
    async sending() {
      this.disableSendWa = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);

      let urlencoded = new URLSearchParams();
      urlencoded.append("order_code", this.orderCode);
      urlencoded.append("contact", this.wa);

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };

      const res = await fetch(
        `${process.env.VUE_APP_BASE_URL}v1/transaction/self_order/send`,
        requestOptions
      );
      const result = await res.json();
      if (result["message"] === "success") {
        this.successAlert();
        this.disableSendWa = false;
        this.product = [];
        this.order = false;
        this.orderCode = "";
        this.qrCode = "";
      }
    },
    //* Show Alert
    showAlert() {
      return alertController
        .create({
          header: "Masukkan nomor WA",
          message: "Masukkan nomor WhatsApp anda dengan benar",
          buttons: ["OK"],
        })
        .then((a) => a.present());
    },
    //* Showign success alert
    successAlert() {
      return alertController
        .create({
          header: "Sukses",
          message:
            "Kode pesanan telah kami kirimkan ke WhatsApp anda, \ngunakan sebelum batas maksimal yang ditentukan",
          buttons: ["OK"],
        })
        .then((a) => a.present());
    },
    //* Loading
    presentLoading() {
      return loadingController
        .create({
          message: "Loading",
          duration: this.timeout,
        })
        .then((l) => {
          setTimeout(function () {
            l.dismiss();
          }, this.timeout);
          return l.present();
        });
    },
    detailsProduct(product) {
      this.outletStore.setShowProductDetail(true)
      this.showProductDetails = !this.showProductDetails;
      this.productDetails = product;
    },
    hideBackdrop() {
      this.showProductDetails = !this.showProductDetails;
      if (this.showLinkInput) {
        this.showLinkInput = !this.showLinkInput;
      }
    },
    hideBackdropOrder() {
      const outletStore = useOutletStore()
      this.backdropOrder = !this.backdropOrder;
      // this.order = false;
      this.outletStore.setOrder(false)
      outletStore.setshowPaymentOptionDialog(false)
    },
    generateUrl(url) {
      this.url = url;
      this.showLinkInput = !this.showLinkInput;
    },
    checkProductAlready() {
      if (this.productDetails.id != undefined) {
        for (let i = 0; i < this.product.length; i++) {
          if (this.productDetails.id == this.product[i].product_id) {
            return true;
          }
        }
      }
      return false;
    },
    resolveProduct(detailId) {
      if (!this.categories) return null;
      for (const cat of this.categories) {
        if (!cat.products) continue;
        const prod = cat.products.find(p => p.product_detail_id == detailId);
        if (prod) return prod;
      }
      if (this.topPickItems) {
        const foundTop = this.topPickItems.find(p => p.product_detail_id == detailId);
        if (foundTop) return foundTop;
      }
      return null;
    },
    addProductFromDetails(product) {
      const hasLinkMenu = this.linkMenus && this.linkMenus.some(
        (m) => m.product_detail_fkid === product.product_detail_id &&
               m.link_menu_detail &&
               m.link_menu_detail.some(detail => !!this.resolveProduct(detail.product_detail_fkid))
      );

      if (hasLinkMenu) {
        this.outletStore.setShowProductDetail(false);
        this.showProductDetails = false;
        
        this.onOpenLinkMenu({
          name: product.product_name,
          price: product.price,
          product_id: product.product_id,
          product_detail_id: product.product_detail_id,
          photo: product.photo,
          note: product.note,
          tax: product.tax,
        });
        return;
      }

      this.product.push(product);
      this.showProductDetails = !this.showProductDetails;
      if (this.showLinkInput) {
        this.showLinkInput = !this.showLinkInput;
      }
      const outlet_id = this.$route.params.id;
      storage.setLastOrder(JSON.stringify({ outlet_id, products: this.product }))
    },
    onOpenLinkMenu(product) {
      this.parentProductForLinkMenu = product;
      this.showLinkMenuDialog = true;
    },
    closeLinkMenuDialog() {
      this.showLinkMenuDialog = false;
      this.parentProductForLinkMenu = null;
    },
    confirmLinkMenuSelection(selectedItems) {
      const parent = this.parentProductForLinkMenu;
      const permanentTax = parent.tax ? parent.tax.filter(t => t.tax_status === "permanent") : [];

      const cartItem = {
        product_name: parent.name || parent.product_name,
        price: parent.price,
        product_id: parent.product_id,
        product_detail_id: parent.product_detail_id,
        qty: 1,
        photo: parent.photo || parent.image,
        note: parent.note || '',
        tax: permanentTax,
        link_menu: selectedItems
      };

      this.product.push(cartItem);
      this.showLinkMenuDialog = false;
      this.parentProductForLinkMenu = null;

      const outlet_id = this.$route.params.id;
      storage.setLastOrder(JSON.stringify({ outlet_id, products: this.product }));
      
      // Update child component product array reference explicitly
      if (this.$refs.categoryRef) {
        this.$refs.categoryRef.product = this.product;
      }
    },
  },
};
</script>

<style scoped>
ion-toolbar {
  background: black;
}

/* Typography & Core */
.main-content {
  --background: #fcfcfd;
}

.container {
  max-width: 800px;
  margin: 0 auto;
}

/* Custom Header & Search */
.main-header {
  --background: #1a1a1a;
  --color: white;
}

.search-toolbar {
  --background: #1a1a1a;
  padding: 0 8px 8px 8px;
}

.custom-searchbar {
  --border-radius: 12px;
  --background: #ffffff;
  --color: #1e293b;
  --placeholder-color: #64748b;
  --icon-color: #64748b;
  --clear-button-color: #64748b;
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Modern Status Cards */
.status-stack {
  padding-top: 12px;
}

.modern-status-card {
  border-radius: 16px;
  padding: 16px;
  /* margin-bottom: 12px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.modern-status-card.payment {
  background: linear-gradient(135deg, #ff9a44 0%, #fc6076 100%);
  color: white;
}

.modern-status-card.active {
  background: #ffffff;
  border-left: 4px solid #10dc60;
  color: #333;
  margin-top: 14px;
}

.status-info small {
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.6rem;
  opacity: 0.8;
}

.status-info h4 {
  margin: 4px 0;
  font-weight: 700;
  font-size: 1rem;
}

.action-link {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  font-size: 0.75rem;
  backdrop-filter: blur(4px);
}

.active .action-link {
  background: #f4f4f4;
  color: #10dc60;
}

/* Floating Cart Modern */
.fab-cart-container {
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 999;
}

.fab-cart {
  background: var(--primary-color, #8C1115);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.fab-cart:active {
  transform: scale(0.95);
}

.icon-badge-wrapper {
  position: relative;
}

.cart-badge {
  background: white;
  color: var(--primary-color, #8C1115);
  font-weight: 800;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
}

.cart-text {
  font-weight: 600;
  font-size: 0.9rem;
}

/* Footer Styling */
.modern-footer {
  text-align: center;
  padding: 40px 0;
  opacity: 0.5;
}

.modern-footer span {
  font-weight: 800;
  color: var(--primary-color, #8C1115);
}

/* Transitions */
.fade-down-enter-active,
.fade-down-leave-active {
  transition: all 0.4s ease;
}

.fade-down-enter-from,
.fade-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.pop-enter-active {
  animation: pop-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes pop-in {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 0 12px;
}

/* No Search Results Styling */
.no-search-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 16px;
  text-align: center;
  color: #718096;
}

.no-results-icon {
  font-size: 4rem;
  color: #cbd5e0;
  margin-bottom: 16px;
}

.no-search-results h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d3436;
  margin: 0 0 8px 0;
}

.no-search-results p {
  font-size: 0.9rem;
  color: #718096;
  margin: 0;
}
</style>